import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { GST_RATES, calcLine, calcTotals, inr } from './gstUi';

export const emptyLine = () => ({ description: '', unit: 'NA', qty: 1, rate: 0, discount: 0, gstPercent: 18 });

export default function GstLinesEditor({ lines, setLines, items, intra, inclusive }) {
  const patch = (i, p) => setLines(lines.map((l, k) => (k === i ? { ...l, ...p } : l)));
  const pick = (i, id) => {
    const it = items.find((x) => x._id === id);
    if (it) patch(i, { description: it.name, unit: it.unit, rate: it.defaultRate, gstPercent: it.gstPercent });
  };
  const t = calcTotals(lines, intra, inclusive);
  const cell = { padding: 3 };
  return (
    <div>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 720 }}>
          <thead><tr>{['Item', 'Description', 'Qty', 'Unit', inclusive ? 'Rate (incl. GST)' : 'Rate', 'Disc.', 'GST', 'Line total', ''].map((h) => <th key={h} style={{ textAlign: 'left', fontSize: 12, padding: 3 }}>{h}</th>)}</tr></thead>
          <tbody>
            {lines.map((l, i) => (
              <tr key={i}>
                <td style={cell}><select className="form-control" value="" onChange={(e) => pick(i, e.target.value)}><option value="">Pick…</option>{items.map((x) => <option key={x._id} value={x._id}>{x.name}</option>)}</select></td>
                <td style={cell}><input className="form-control" value={l.description} onChange={(e) => patch(i, { description: e.target.value })} /></td>
                <td style={cell}><input className="form-control" style={{ width: 70 }} type="number" min="0" step="any" value={l.qty} onChange={(e) => patch(i, { qty: e.target.value })} /></td>
                <td style={cell}><input className="form-control" style={{ width: 60 }} value={l.unit} onChange={(e) => patch(i, { unit: e.target.value })} /></td>
                <td style={cell}><input className="form-control" style={{ width: 90 }} type="number" min="0" step="0.01" value={l.rate} onChange={(e) => patch(i, { rate: e.target.value })} /></td>
                <td style={cell}><input className="form-control" style={{ width: 80 }} type="number" min="0" step="0.01" value={l.discount} onChange={(e) => patch(i, { discount: e.target.value })} /></td>
                <td style={cell}><select className="form-control" value={l.gstPercent} onChange={(e) => patch(i, { gstPercent: Number(e.target.value) })}>{GST_RATES.map((r) => <option key={r} value={r}>{r}%</option>)}</select></td>
                <td style={{ ...cell, textAlign: 'right' }}>{inr(inclusive ? Math.max(Math.round((Number(l.qty) || 0) * Math.round((Number(l.rate) || 0) * 100)) - Math.round((Number(l.discount) || 0) * 100), 0) / 100 : calcLine(l, intra, inclusive).total)}</td>
                <td style={cell}><button type="button" className="btn btn-secondary" disabled={lines.length === 1} onClick={() => setLines(lines.filter((_, k) => k !== i))}><Trash2 size={14} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button type="button" className="btn btn-secondary" onClick={() => setLines([...lines, emptyLine()])}><Plus size={14} /> Add line</button>
      <div style={{ textAlign: 'right', marginTop: 8, fontSize: 13 }}>
        Taxable {inr(t.taxable)} · {intra ? `CGST ${inr(t.cgst)} · SGST ${inr(t.sgst)}` : `IGST ${inr(t.igst)}`} · <b>Total ₹{inr(t.grandTotal)}</b>
        <div style={{ opacity: 0.6, fontSize: 11 }}>Preview only — the server computes the final amounts.</div>
      </div>
    </div>
  );
}
